import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import locale from './locale/localeSlice'
import notifications from './notifications/notificationsSlice'
import treatmentCategories from './treatmentCategories/treatmentCategoriesSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        locale,
        notifications,
        treatmentCategories,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
